import React from "react";
import Header from "../components/Header/Header";
import Navbar from "../components/Navbar/Navbar";
import dheeraj from "../components/assets/dheeraj.jpeg"
import sajal from "../components/assets/sajal.jpg"
import devanshi from "../components/assets/devanshi.jpg"
export default function WebTeamPage() {
  const teamMembers = [
    {
      name: "Dheeraj Sharma",
      linkedin: "https://www.linkedin.com/in/dheeraj5948/",
      email: "dheerajsharma5948@gmail.com",
      image: dheeraj, // Add your image URL here
    },
    {
      name: "Sajal Kumar Babu Degala",
    //   role: "Backend Developer",
      linkedin: "https://www.linkedin.com/in/sajal-k-9b4652b8/",
      email: "sajal.kumar3@gmail.com",
      image: sajal, // Add your image URL here
    },
    {
      name: "Devanshi Gupta",
    //   role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/devanshi0503/",
      email: "devanshi2k26@gmail.com",
      image :devanshi, // Add your image URL here
    },
  ];

  return (
    <div>
      <Header />
      <Navbar />
      <div className="bg-gray-50 min-h-screen py-10">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
            Meet the Web Team
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg p-6 text-center"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 rounded-full mx-auto mb-4"
                />
                <div className="text-2xl font-semibold text-gray-700 mb-2">
                  {member.name}
                </div>
                <p className="text-gray-600 mb-4">{member.role}</p>
                <div className="space-y-2">
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline block"
                  >
                    LinkedIn
                  </a>
                  <a
                    href={`mailto:${member.email}`}
                    className="text-gray-700 hover:underline block"
                  >
                    {member.email}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
